<script>
  import { createEventDispatcher } from 'svelte';
  import { writable } from 'svelte/store';
  $: scrollPosition = writable(0);
  const dispatch = createEventDispatcher();

  function handleScroll() {
    scrollPosition.set(window.scrollY);
  }
  $: isVisible = true;

  $: {
    scrollPosition.subscribe((value) => {
      // let isVisible;

      // if (value <= 600 || value > 1400) {
      //   isVisible = false;
      // } else if (max === 0 || (value > 400 && value < max - 150)) {
      //   isVisible = true;
      // } else if (value > max && max !== 0) {
      //   isVisible = false;
      // }

      // if (value <= 300 || value > 1660) {
      //   isVisible = false;
      // } else {
      //   isVisible = true;
      // }
      if (value <= 400 || value > 1660) {
        isVisible = false;
      } else {
        isVisible = true;
      }

      dispatch('update', { isVisible });
    });
  }
</script>

<svelte:window on:scroll={handleScroll} />
<div class="scroll-wrapper">
  {#if isVisible}
    <slot name="background" />
  {/if}
</div>

<style>
  .scroll-wrapper {
    position: relative;
    height: 100%;
    overflow-y: scroll;
  }
</style>
